import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import Select from "react-select";
import ScreenLoader from "views/Components/screenLoader";
import { getTickets, UpdateNewTicket,UpdateNewTicketRow } from "Listfunction";

class EditTicket extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ticket_type: "1",
      platform: "",
      severity: "",
      description: "",
      platformErr: "",
      severityErr: "",
      descriptionErr: "",
      isLoading: false,
      attachments: [],
      isSubmitted: false,
      errormessages: [],
      cardHidden: true,
      isAttachmentChanged: false,
      status:''
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
  }

  upload() {
    document.getElementById("ticket_attachment").click();
  }

  handleFileChange(event) {
    let data = [];
    for (let i = 0; i < event.target.files.length; i++) {
      data.push(event.target.files[i]);
    }

    this.setState({ attachments: data, isAttachmentChanged: true });
  }

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Ticket</b> - Updated Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 3,
    });
    setTimeout(() => {
      this.props.history.push("/admin/tickets");
    }, 2000);
  }

  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 5,
    });
  }

  handleClick(position, message) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>{message}</b>
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 5,
    });
  }

  async componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    var id = localStorage.getItem("tic_id");
    getTickets(id, obj)
      .then((res) => {
        if (res.success == true) {
          var data = res.data.Ticket;

          var type = data.type == "Bug" ? "1" : "2";
          var platform = "";
          if (data.platform == "Flash App") {
            platform = { value: "1", label: "Flash App" };
          } else if (data.platform == "Flash Admin") {
            platform = { value: "2", label: "Flash Admin" };
          } else if (data.platform == "First Advice Doctor Panel") {
            platform = { value: "3", label: "First Advice Doctor Panel" };
          } else if (data.platform == "Rider App") {
            platform = { value: "4", label: "Rider App" };
          }

          var severity = "";
          if (data.priority == "High") {
            severity = { value: "1", label: "High" };
          } else if (data.priority == "Medium") {
            severity = { value: "2", label: "Medium" };
          } else if (data.priority == "Low") {
            severity = { value: "3", label: "Low" };
          }

          this.setState({
            ticket_type: type,
            platform: platform,
            severity: severity,
            description: data.description,
            attachments: data.files ? data.files : [],
            status: data.status
          });
        }
      })
      .catch((err) => console.log(err));

    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
  }

  async onSubmit() {
    var error = false;
    var platform_Err = "";
    var severify_Err = "";
    var description_Err = "";

    if (this.state.platform == "" || this.state.platform == null) {
      error = true;
      platform_Err = (
        <small className="text-danger">Please select platform</small>
      );
    }

    if (this.state.severity == "" || this.state.severity == null) {
      error = true;
      severify_Err = (
        <small className="text-danger">Please select severity</small>
      );
    }

    if (this.state.description == "" || this.state.description == null) {
      error = true;
      description_Err = (
        <small className="text-danger">Please enter description</small>
      );
    }

    if (error) {
      this.setState({
        platformErr: platform_Err,
        severityErr: severify_Err,
        descriptionErr: description_Err,
        isSubmitted: true,
      });
    }

    if (!error) {
      this.setState({
        isLoading: true,
        isSubmitted: true,
      });

      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      var id = localStorage.getItem("tic_id");

      var type =
        this.state.ticket_type == 1
          ? "Bug"
          : this.state.ticket_type == 2
          ? "Improvement"
          : "";
      var platform = this.state.platform.label;
      var severity = this.state.severity.label;

      if (this.state.isAttachmentChanged) {
        let fdata = new FormData();
        let atchFiles = this.state.attachments;
        for (let i = 0; i < atchFiles.length; i++) {
          fdata.append("files[]", atchFiles[i]);
        }
        fdata.append("lead_id", token.id);
        fdata.append("type", type);
        fdata.append("platform", platform);
        fdata.append("severity", severity);
        fdata.append("description", this.state.description);
        fdata.append('status',this.state.status)

        UpdateNewTicket(obj, fdata, id)
          .then((res) => {
            if (res.success == true) {
              this.handleSuccess("bl");
            } else {
              console.log(res);
              this.setState({
                isLoading: false,
              });
            }
          })
          .catch(() => {
            this.handleNetworkError("bl");
            this.setState({
              isLoading: false,
            });
          });
      } else {
        UpdateNewTicketRow(
          obj,
          token.id,
          severity,
          platform,
          type,
          this.state.description,
          this.state.attachments,
          this.state.status,
          id
        )
          .then((res) => {
            if (res.success == true) {
              this.handleSuccess("bl");
            } else {
              console.log(res);
              this.setState({
                isLoading: false,
              });
            }
          })
          .catch(() => {
            this.handleNetworkError("bl");
            this.setState({
              isLoading: false,
            });
          });
      }
    }
  }

  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    if (this.state.isSubmitted) {
      this.validate(value, name);
    }

    this.setState({
      [name]: value,
    });
  };

  validate = (value, name) => {
    if (name == "description") {
      if (value == "" || value == null) {
        this.setState({
          descriptionErr: (
            <small className="text-danger">Please enter description</small>
          ),
        });
      } else {
        this.setState({
          descriptionErr: null,
        });
      }
    }
  };

  removeFileItem = (num) => {
    var dataList = this.state.attachments;
    dataList.splice(num, 1);
    this.setState({
      attachments: dataList,
    });
  };

  render() {
    const errormessages = this.state.errormessages;
    return (
      <div className="main-content">
        <input
          style={{ width: "0px", height: "0px", border: "none" }}
          type="text"
          ref=""
        />

        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Card
            content={
              <form>
                {errormessages.length != 0 && (
                  <div className=" alert alert-danger">
                    {errormessages.map((data) => (
                      <React.Fragment>
                        <li>{data}</li>
                      </React.Fragment>
                    ))}
                  </div>
                )}

                <Row>
                  <Col xs={12} sm={6} md={4}>
                    <FormGroup>
                      <ControlLabel>Ticket Type</ControlLabel>
                      <div className="ticket_type_radio">
                        <Radio
                          number="1"
                          option="1"
                          name="ticket_type"
                          onChange={(e) => this.onChange(e)}
                          checked={this.state.ticket_type === "1"}
                          label="Bug"
                        />
                        <Radio
                          number="2"
                          option="2"
                          name="ticket_type"
                          onChange={(e) => this.onChange(e)}
                          checked={this.state.ticket_type === "2"}
                          label="Improvement "
                        />
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={6} md={6} lg={4}>
                    <FormGroup>
                      <ControlLabel>Platform</ControlLabel>
                      <Select
                        placeholder="Platform"
                        name="platform"
                        value={this.state.platform}
                        onChange={(value) =>
                          this.setState({
                            platform: value,
                            platformErr: "",
                          })
                        }
                        options={[
                          { value: "1", label: "Flash App" },
                          { value: "2", label: "Flash Admin" },
                          { value: "3", label: "First Advice Doctor Panel" },
                          { value: "4", label: "Rider App" },
                        ]}
                      />
                      {this.state.platformErr}
                    </FormGroup>
                  </Col>
                  <Col xs={12} sm={6} md={6} lg={4}>
                    <FormGroup>
                      <ControlLabel>Severity</ControlLabel>
                      <Select
                        className="secondary"
                        placeholder="Severity "
                        name="severity"
                        value={this.state.severity}
                        onChange={(value) =>
                          this.setState({
                            severity: value,
                            severityErr: "",
                          })
                        }
                        options={[
                          { value: "1", label: "High" },
                          { value: "2", label: "Medium" },
                          { value: "3", label: "Low" },
                        ]}
                      />
                      {this.state.severityErr}
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={12} lg={8}>
                    <FormGroup>
                      <ControlLabel>Description</ControlLabel>
                      <textarea
                        className="form-control"
                        value={this.state.description}
                        placeholder="Enter Message"
                        name="description"
                        onChange={(e) => this.onChange(e)}
                        rows={5}
                        style={{ resize: "none" }}
                      />
                      {this.state.descriptionErr}
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <FormGroup>
                      <ControlLabel>Attachment</ControlLabel>
                      <input
                        style={{ display: "none" }}
                        id="ticket_attachment"
                        type="file"
                        className="form-control"
                        name="ticket_attachment"
                        multiple
                        onChange={this.handleFileChange.bind(this)}
                      />
                      <Button
                        onClick={this.upload}
                        style={{ color: "#2B3A41", display: "block" }}
                      >
                        {" "}
                        <i
                          className={
                            this.state.attachments == ""
                              ? "fa fa-plus"
                              : "fa fa-pencil fa-fw"
                          }
                        ></i>{" "}
                        {this.state.attachments == ""
                          ? "Choose File"
                          : "Change File"}
                      </Button>
                    </FormGroup>
                  </Col>
                  <Col xs={12} className="attecth_filelist">
                    {this.state.attachments.length > 0 &&
                      this.state.attachments.map((attch, idx) => (
                        <div className="attecth_filelist_row">
                          <h6 key={idx}>
                            <a
                              href={
                                !this.state.isAttachmentChanged
                                  ? attch
                                  : URL.createObjectURL(attch)
                              }
                              target="_blank"
                            >
                              {!this.state.isAttachmentChanged
                                ? `File ${idx + 1}`
                                : attch.name}
                            </a>
                          </h6>
                          <p onClick={() => this.removeFileItem(idx)}>x</p>
                        </div>
                      ))}
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <Button
                      onClick={this.onSubmit.bind(this)}
                      className="btn-color"
                      fill
                    >
                      Save
                    </Button>
                  </Col>
                </Row>
              </form>
            }
          />
        </Grid>
        {this.state.isLoading ? <ScreenLoader /> : ""}
      </div>
    );
  }
}

export default EditTicket;
